/**
 * User: hella
 * Date: 6/3/14
 * Time: 8:18 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var nonStickyPageIds = ['checkout', 'checkoutBalanceDue'];
var hasScrolled      = false;

module.exports = {

    isPageAllowed: function isPageAllowed(arr) {
        arr = arr || nonStickyPageIds;
        var i = arr.length;
        var id = document.body.id;
        while (i--) {
            if (arr[i] === id) {
                return false;
            }
        }
        return true;
    },

    scrollOffset: function scrollOffset() {
        var x = (!!typeof(window.pageXOffset)) ? window.pageXOffset : document.documentElement.scrollLeft;
        var y = (!!typeof(window.pageYOffset)) ? window.pageYOffset : document.documentElement.scrollTop;
        return { x: x, y: y };
    },

    /**
     * @returns {boolean}
     */
    getHasScrolled: function getHasScrolled() {
        return hasScrolled;
    },

    /**
     * @param scroll
     */
    setHasScrolled: function setHasScrolled(scroll) {
        hasScrolled = scroll;
    },

    /**
     * Get x digits of entropy
     * @param digits
     * @returns {number}
     */
    getEntropy: function getEntropy(digits) {
        digits = digits || 8;
        return Math.floor(Math.random() * Math.pow(10, digits));
    }
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/nav/navHelpers.js
// module id = 2562
// module chunks = 62